/*
  Staff Snap prev / next carets for the mobile row (Figma "Mobile" page, node
  1024:18505). The Staff Start app owns the card markup, so the carets are
  added here, once per block, after its card rows. staff-start.css shows them
  below 750px only, where the row scrolls sideways.

  Each block renders one row per gender and the header hides the other one, so
  a click scrolls whichever row is visible, by one tile.
*/
(function () {
  // The Figma btn-nav caret, the same drawing as assets/icon-btn-nav-*.svg
  var CARET_PATHS = {
    prev: 'M14.6667 6.6667L9.3333 12L14.6667 17.3333',
    next: 'M9.3333 6.6667L14.6667 12L9.3333 17.3333',
  };

  function visibleRow(container) {
    var rows = container.querySelectorAll('.staff-snap__cards');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].offsetParent !== null) return rows[i];
    }
    return null;
  }

  // One tile plus the gap, so each click lands the next tile on the snap point.
  function tileStep(row) {
    var tile = row.querySelector('.staff-snap__card');
    if (!tile) return row.clientWidth;
    var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
    return tile.getBoundingClientRect().width + gap;
  }

  function createCaret(direction, label) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'staff-snap__caret';
    button.setAttribute('aria-label', label);
    button.dataset.direction = direction;
    button.innerHTML =
      '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">' +
      '<path d="' + CARET_PATHS[direction] + '" fill="none" stroke="currentColor" stroke-width="0.8" stroke-linecap="round"/>' +
      '</svg>';
    return button;
  }

  function addCarets(container) {
    if (container.querySelector('.staff-snap__carets')) return;
    var rows = container.querySelectorAll('.staff-snap__cards');
    if (!rows.length) return;

    var carets = document.createElement('div');
    carets.className = 'staff-snap__carets';
    carets.appendChild(createCaret('prev', '前へ'));
    carets.appendChild(createCaret('next', '次へ'));
    carets.addEventListener('click', function (event) {
      var button = event.target.closest('.staff-snap__caret');
      var row = button && visibleRow(container);
      if (!row) return;
      var sign = button.dataset.direction === 'prev' ? -1 : 1;
      row.scrollBy({ left: sign * tileStep(row), behavior: 'smooth' });
    });

    rows[rows.length - 1].after(carets);
  }

  function init() {
    document.querySelectorAll('.staff-snap__container').forEach(addCarets);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
